import { toast } from 'react-toastify';
import { companyCodes, validationRules } from '../constants';

/**
 * @function
 * @param {string} query
 * @returns {string} capitalized query
 */

export const capitalizeInput = (query) => {
    const queryArray = query.split(" ");

    const capitalizedArr = queryArray.map(
        (query) => query.charAt(0).toUpperCase() + query.slice(1)
    );
    return capitalizedArr.join(" ");
};

/**
 * @function
 * @param {array} products
 * @returns {array | null} with certain properties
 */

export const mapProducts = (products) => {
    if (!products) {
        return null;
    }

    return products.map((product) => {
        const { title, tags, body_html, id, image, product_type } = product;
        return {
            title,
            tags,
            body_html,
            id,
            image: image.src,
            type: product_type,
        };
    });
};

/**
 * @function
 * @param {object, function} file setError
 * @returns {boolean || setError} consider specified condition check
 */

export const imageTypeCheck = (file, setError) => {
    const acceptableImageTypes = ["image/png", "image/jpg", "image/jpeg"];
    
    if (acceptableImageTypes.includes(file.type)) {  // if user selected file is an image file
        setError(null);
        return true;
    } else {
        setError(`Yalnızca ${acceptableImageTypes.map(type => type.split('/')[1]).map(item => ` ${item}`)} türünde dosyaları yükleyebilirsiniz.`);
        return false;
    }
}

/**
 * @function
 * @param {object, integer, integer, function, function} file widthSize heightSize setState setError
 * @returns {boolean} consider specified condition check
 */

export const imageValidCheck = (file, widthSize, heightSize, setState, setError) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file);
    reader.onload = function (e) {

        //Initiate the JavaScript Image object.
        var image = new Image();

        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result;

        image.onload = function () {
            setState(image.src);
            setError(null);
        };

        return true;
    };
}

export const asyncToaster = (promise, {
    loading = 'Loading',
    success = 'Got the data',
    error = 'Error when fetching'
}) => {
    toast.promise(promise, {
        loading,
        success,
        error,
    })
};

/**
 * @function
 * @param {string} companyCode
 * @returns {boolean } checks if companyCode is valid
 */

export const checkCompanyCode = (companyCode) => {
    if (companyCodes['oztabak'] !== companyCode) {
        return false;
    }

    return true;
};

/**
 * @function
 * @param {string} pathName
 * @returns {string} the previous path
 */

export const backToPreviousPath = (pathName) => {
    const index = pathName.lastIndexOf('/')
    const previousPath = pathName.slice(0, index)
    return previousPath
};

/**
 * @function
 * @param {string} form // the name of the form
 * @param {object} errors // usually this is the errors object
 * @param {object} values // usually this is the values object
 * @returns {object} // returns an object with the error state and the errors
 */

export const validateForm = (form, errors, values) => {
    const _errors = {};
    const _values = Object.keys(errors);
    _values.forEach((key) => {

        // each field in the form
        const field = validationRules[form].fields[key];

        if (field.regexPattern) {
            if (!values[key].match(field.regexPattern)) {
                _errors[key] = field.regexMessage;
            }
        }

        if (!!field.pattern && field.pattern !== values[key]) {
            _errors[key] = field.message
        }

        if (key === 'passwordConfirmation') {
            if (values[key] !== values['password']) {
                _errors[key] = field.message
            }
        }
    });

    return {
        error: Object.keys(_errors).length > 0,
        errors: _errors
    };
}

export const formatDate = (date) => {
    date = new Date(date);
    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1; // Months start at 0!
    let dd = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    date = dd + '/' + mm + '/' + yyyy;

    return date;
}

export const parseDate = (date) => {
    // todo: fix this
    if (!date) {
        return new Date();
    }

    const dateArray = date.includes('/') ? date.split('/') : date.split('-');
    const day = dateArray[0];
    const month = dateArray[1];
    const year = dateArray[2];
    const parsedDate = new Date(year, month - 1, day);
    return parsedDate;
}

export const getTime = (date) => {

    function padTo2Digits(num) {
        return String(num).padStart(2, '0');
    }

    const hoursAndMinutes =
        padTo2Digits(date.getHours()) + ':' + padTo2Digits(date.getMinutes());

    return hoursAndMinutes;
}


